import { connect } from 'react-redux';
import { selectActiveVenueId } from 'selectors/general';
import ScheduleIncrementsButton from './ScheduleIncrementsButton';

export const mapStateToProps = state => {
  return {
    venueId: selectActiveVenueId(state),
  };
};

export default connect(mapStateToProps)(ScheduleIncrementsButton);
